import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { nameof } from 'ts-simple-nameof';
import { PagedSearchDto } from '../../../../../../../libs/utils/ts-shared/src/lib/api/searching/dtos/PagedSearchDto';
import { GridMenuItem } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid-menu/grid-menu-item';
import { GridComponent } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/grid.component';
import { FilterType } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/filter-type';
import { CellValueType, IGridColumn } from '../../../../../../../libs/utils/ng-shared-components/src/lib/grid/interface/grid-column';
import { ModalService } from '../../../../../../../libs/utils/ng-shared-components/src/lib/services/modal.service';
import { CollectOrderDto } from '../../../../api/dtos/CollectOrderDto';
import { CollectOrderFiltersDto } from '../../../../api/dtos/CollectOrderFiltersDto';
import { OrderDto } from '../../../../api/dtos/OrderDto';
import { ApiClientAdminCollectOrder } from '../../../../api/endpoints/ApiClientAdminCollectOrder';
import { HttpApiRequestOptions } from '../../../../api/endpoints/HttpApiRequestOptions';
import { OrderStatus } from '../../../../api/enums/OrderStatus';
import { OrderType } from '../../../../api/enums/OrderType';
import { enumName_mi_pspc } from '../../../../api/enums/_enumName.mi_pspc';
import { CollectOrderVoucherCreateComponent } from '../collect-order-voucher/collect-order-voucher-create.component';
import { CollectOrderCreateComponent } from './collect-order-create.component';
import { CollectOrderEditComponent } from './collect-order-edit.component';
import { TrackingPopupComponent } from '../../../components/track-grid/tracking-popup.component';
import { Icons } from '../../../../../../../libs/utils/ng-shared-components/src/lib/icon/icons';
import { FilterEntityType } from '../../../view-models/FilterEntityType';
import { CollectOrderEditExternalIdComponent } from './collect-order-edit-external-id.component';
import { ActivatedRoute } from '@angular/router';
import { OperationService } from '../../operation/operation.service';
import { OperationDetailsComponent } from '../../operation/operation-details.component';
import { OperationEditComponent } from '../../operation/operation-edit.component';

@Component({
  standalone: false,
  selector: 'mf-collect-order-grid',
  templateUrl: './collect-order-grid.component.html',
  styleUrls: ['./collect-order-grid.component.scss'],
})
export class CollectOrderGridComponent implements OnInit {
  constructor(
    public _apiClientAdminCollectOrder: ApiClientAdminCollectOrder,
    private _modalService: ModalService,
    private _activatedRoute: ActivatedRoute,
    private _operationService: OperationService
  ) {}

  @ViewChild('grid')
  grid: GridComponent;

  @Input() disableCreateButton = false;
  @Input() actionButtonAsSecondary = false;
  @Input() hideFilters = false;
  @Input() operationId: string;
  @Input() showCreateButton = false;
  @Input() allowEdit = false;

  filters: CollectOrderFiltersDto;

  ngOnInit(): void {
    this.filters = new CollectOrderFiltersDto();
    let operationId = this._activatedRoute.snapshot.queryParams['operationId'];
    if (operationId) {
      this.filters.operationId = operationId;
    } else {
      this.filters.operationId = this.operationId;
    }
  }

  mustIncludeFields = [
    nameof<CollectOrderDto>((e) => e.operationId),
    nameof<CollectOrderDto>((e) => e.personId),
    nameof<CollectOrderDto>((e) => e.clientId),
  ];

  columns: IGridColumn<CollectOrderDto>[] = [
    {
      field: nameof<CollectOrderDto>((o) => o.operation.operationNumber),
      header: 'Operación',
      width: 5,
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.operationNumber),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<CollectOrderDto>((o) => o.operation.reason),
      header: 'Razón',
      width: 10,
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.operationReason),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<CollectOrderDto>((o) => o.orderNumber),
      header: 'Número',
      width: 5,
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.orderNumber),
        type: FilterType.Number,
      },
    },
    {
      field: nameof<CollectOrderDto>((o) => o.reference),
      header: 'Referencia',
      width: 10,
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.reference),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<CollectOrderDto>((o) => o.externalId),
      header: 'Id externo',
      width: 6,
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.externalId),
        type: FilterType.Text,
      },
    },
    {
      field: nameof<CollectOrderDto>((o) => o.person.fullName),
      header: 'Persona',
      width: 15,
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.person),
        type: FilterType.Entity,
        entityType: FilterEntityType.Person,
      },
    },
    {
      field: nameof<OrderDto>((o) => o.status),
      header: 'Estado',
      width: 10,

      cellOptions: {
        type: CellValueType.Enum,
        enumName: enumName_mi_pspc.OrderStatus,
      },
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.statusList),
        type: FilterType.EnumList,
        enumName: enumName_mi_pspc.OrderStatus,
      },
    },

    { field: nameof<CollectOrderDto>((o) => o.destinationBankAccount.bank.name), header: 'Banco', width: 5 },
    { field: nameof<CollectOrderDto>((o) => o.destinationBankAccount.accountNumber), header: 'Cuenta', width: 5 },
    {
      field: nameof<CollectOrderDto>((o) => o.operation.currency),
      header: 'Moneda',
      width: 5,
      align: 'right',
      cellOptions: {
        type: CellValueType.Enum,
        enumName: enumName_mi_pspc.Currency,
      },
      filter: {
        propertyName: nameof<CollectOrderFiltersDto>((o) => o.currency),
        type: FilterType.EnumList,
        enumName: enumName_mi_pspc.Currency,
      },
    },
    {
      field: nameof<CollectOrderDto>((o) => o.amount),
      header: 'Monto',
      width: 8,
      cellOptions: {
        type: CellValueType.Numeric,
      },
    },
  ];

  menuItems: GridMenuItem[] = [
    {
      label: 'Editar',
      icon: Icons.edit,
      hide: (collectOrderDto: CollectOrderDto) => collectOrderDto.status != OrderStatus.Draft && this.allowEdit == false,
      onClick: (collectOrderDto: CollectOrderDto) => {
        this._modalService.openLargeModal(CollectOrderEditComponent, {
          openData: {
            collectOrderId: collectOrderDto.id,
          },
          onCloseSuccess: () => {
            this.grid.reloadPage();
            this._operationService.reloadOperation(this.operationId);
          },
        });
      },
    },
    {
      label: 'Cambiar Id externo',
      icon: Icons.edit,
      hide: (collectOrderDto: CollectOrderDto) => collectOrderDto.status == OrderStatus.Draft,
      onClick: (collectOrderDto: CollectOrderDto) => {
        this._modalService.openLargeModal(CollectOrderEditExternalIdComponent, {
          openData: collectOrderDto.id,
          onCloseSuccess: () => {
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Abrir operación',
      icon: Icons.operations,
      onClick: (collectOrderDto: CollectOrderDto) => {
        this._modalService.openRightModal(OperationEditComponent, {
          openData: {
            operationId: collectOrderDto.operationId,
          },
          onCloseSuccess: async () => {},
        });
      },
    },
    {
      label: 'Ver tracking',
      icon: Icons.list,
      onClick: (collectOrderDto: CollectOrderDto) => {
        this._modalService.openRightModal(TrackingPopupComponent, {
          openData: collectOrderDto.id,
          onCloseSuccess: async () => {},
        });
      },
    },
    {
      label: 'Eliminar',
      icon: Icons.delete,
      hide: (collectOrderDto: CollectOrderDto) => collectOrderDto.status != OrderStatus.Draft,
      onClick: (collectOrderDto: CollectOrderDto) => {
        this._modalService.openYesOrNoModal({
          openData: {
            title: '¿Está seguro de eliminar la orden de cobro?',
          },
          onCloseSuccess: async () => {
            await this._apiClientAdminCollectOrder.delete(collectOrderDto.id);
            this.grid.reloadPage();
          },
        });
      },
    },
    {
      label: 'Cargar comprobante',
      icon: Icons.upload,
      hide: (collectOrderDto: CollectOrderDto) =>
        collectOrderDto.status !== OrderStatus.Pending && collectOrderDto.type !== OrderType.Collect,
      onClick: (collectOrderDto: CollectOrderDto) => {
        this._modalService.openLargeModal(CollectOrderVoucherCreateComponent, {
          openData: {
            collectOrderId: collectOrderDto.id,
            collectOrderAmount: collectOrderDto.amount,
            personId: collectOrderDto.personId,
            currency: collectOrderDto.operation.currency,
            clientId: collectOrderDto.clientId,
          },
          onCloseSuccess: () => {
            this.grid.reloadPage();
          },
        });
      },
    },
  ];

  apiEndpoint = (search: PagedSearchDto<CollectOrderFiltersDto>, httpApiRequestOptions: HttpApiRequestOptions) =>
    this._apiClientAdminCollectOrder.getPaged(search, httpApiRequestOptions);

  openNewCollectOrderPopup() {
    this._modalService.openLargeModal(CollectOrderCreateComponent, {
      openData: {
        operationId: this.operationId,
      },
      onCloseSuccess: () => {
        this.grid.reloadPage();
      },
    });
  }
}
